export const safeJsonParse = (value: any, defaultValue = {}) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    console.warn(`safeJsonParse: Error trying to parse ${value}`);
    return defaultValue;
  }
};
